import React from 'react';
import { Modal, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import { ModalBox, CloseButton, ApplianceItemButton } from './styles';

const ApplianceModal = ({ isOpen, onClose, selectedWarehouse }) =>
  (
    <Modal
      open={isOpen}
      onClose={onClose}
      aria-labelledby="appliances-modal-title"
      aria-describedby="appliances-modal-description"
    >
      <ModalBox>
        <CloseButton
          aria-label="close"
          onClick={onClose}
        >
          <CloseIcon />
        </CloseButton>
        <Typography gutterBottom variant="h4" pb={2} id="appliances-modal-title">Appliances</Typography>
        {selectedWarehouse && (
          <div id="appliances-modal-description">
            {selectedWarehouse.appliances?.map(applianceItem => (
              <ApplianceItemButton
                key={applianceItem.id}
                color="secondary"
                aria-label="Application"
                component={Link}
                to={`/warehouse/appliance/edit/${applianceItem.id}`}
              >
                {applianceItem.label}
              </ApplianceItemButton>
            ))}
          </div>
        )}
      </ModalBox>
    </Modal>
  );

export default ApplianceModal;
